import React, { Component } from "react";
import NodataFound from "../assets/no_data_found 1.png"
class PragatiNoDataFound extends Component {
  render() {
    return (
      <div className="no-data-wrapper" style={{background:"#F4F8FC",marginLeft:30}}>
        <img
          src={NodataFound}
          alt="No Data"
          style={{paddingTop:35}}
        />
        <h3 className={`no-data-found`} style={{paddingBottom:20,fontSize:"19px",paddingTop:5,fontFamily:"mpb"}}>
          No Projects or Issues Added
        </h3>
      </div>
    );
  }
}

export default PragatiNoDataFound;
